import apiClient, { setReaderToken } from './apiClient';

export async function registerReader({ displayName, email, password }) {
  const response = await apiClient.post('/auth/reader/register', {
    displayName,
    email,
    password,
  });
  return response.data;
}

export async function loginReader({ email, password }) {
  const response = await apiClient.post('/auth/reader/login', { email, password });
  return response.data;
}

export async function getReaderMe(token) {
  const response = await apiClient.get('/auth/reader/me', {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  return response.data;
}

export async function getReaderComments(params = {}) {
  const response = await apiClient.get('/auth/reader/comments', { params });
  return response.data;
}

export async function updateReaderComment(commentId, body) {
  const response = await apiClient.patch(`/auth/reader/comments/${commentId}`, { body });
  return response.data;
}

export async function deleteReaderComment(commentId) {
  const response = await apiClient.delete(`/auth/reader/comments/${commentId}`);
  return response.data;
}

export async function verifyReaderEmail(token) {
  const response = await apiClient.post('/auth/reader/verify-email', { token });
  return response.data;
}

export async function resendVerificationEmail() {
  const response = await apiClient.post('/auth/reader/resend-verification');
  return response.data;
}

export async function requestPasswordReset(email) {
  const response = await apiClient.post('/auth/reader/forgot-password', { email });
  return response.data;
}

export async function resetPassword({ token, password }) {
  const response = await apiClient.post('/auth/reader/reset-password', { token, password });
  return response.data;
}

export function persistReaderToken(token) {
  setReaderToken(token);
}

export { getStoredReaderToken } from './apiClient';
